export const didYouKnow = [
  {
    fact: 'Over 500 manufacturers on the MakerSharks platform have completed their profiles and are now connecting with new business opportunities!',
  },
  {
    fact: 'MakerSharks helps manufacturers expand their reach by connecting them with clients looking for quality, verified suppliers!',
  },
  {
    fact: 'Suppliers on MakerSharks gain access to a growing network of buyers actively seeking reliable manufacturing partners.',
  },
  {
    fact: 'MakerSharks uses advanced algorithms to match buyers with the right suppliers, creating meaningful connections in just a few clicks.',
  },
  {
    fact: 'On MakerSharks, buyers can easily browse profiles and see real-time updates from manufacturers they’re interested in working with.',
  },
  {
    fact: 'MakerSharks is designed to simplify sourcing, saving businesses time by connecting them directly to trusted suppliers.',
  },
  {
    fact: 'Verified suppliers on MakerSharks stand out, giving buyers the confidence to make partnerships that last.',
  },
  {
    fact: 'MakerSharks has streamlined the onboarding process for suppliers, making it easy to set up and showcase capabilities in minutes.',
  },
  {
    fact: 'Buyers on MakerSharks benefit from an intuitive platform, helping them discover manufacturers who meet their specific project needs.',
  },
  {
    fact: 'MakerSharks is trusted by hundreds of businesses looking to make sourcing and manufacturing partnerships simpler and faster.',
  },
]; // define any constant which is used throughout the app.
